export default "__VITE_ASSET__F99U4kTj__";